import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../common/services/common.service';
import { ForgotPasswordService } from '../forgot-password/forgot.service';

@Component({
    selector: 'app-reset-password',
    templateUrl: 'reset-password.component.html',
    styleUrls:['./reset-password.component.css']
})

export class ResetPasswordComponent implements OnInit {
    guid:string='';
    password:string='';
    confirmPassword:string='';
    success:boolean=false;
    errorMap = new Map();
    constructor(private forgot:ForgotPasswordService,private route: ActivatedRoute,private _router: Router,private common:CommonService) { }
    
    ngOnInit() { 
    //  this.guid =   this.route.snapshot.queryParamMap.get('id')
    
    }


    validatePassword(){
        if(this.password != null){
            this.errorMap.set('password',false);
            if(this.password.length < 6){
                this.errorMap.set('passwordLength',true);
            }else{
                this.errorMap.set('passwordLength',false);
                if(this.password != this.confirmPassword){
                    this.errorMap.set('confirm',true) 
                }else{
                    this.errorMap.clear();
                    this.UpdatePassword();
                }
            }
           
        }else{
            this.errorMap.set('password',true);
        }
      
    }

    UpdatePassword(){
        var req = {
            'Code':this.route.snapshot.paramMap.get('id'),
            'Password':this.password
        }
        this.forgot.updatePassword(req).subscribe((response:any)=>{
            if(response.message = 'message' && response.status){
                this.success = true;

            }
        });


    }
    
}